import type { Revalidator, RevalidatorOptions, SWRConfiguration } from '@ori/fetching';
import { Team } from '@ori/testid-generator';

import type { ApiError } from '../models';

/**
 * Identity server client ID for authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';

/**
 * Name of this app.
 */
export const APP_NAME = 'online-top-banner';

/**
 * Team which owns this SPA.
 */
export const APP_TEAM_NAME: Team = Team.Presentation;

/**
 * Serves as identifier to the root of this SPA in the HTML:
 */
export const APP_ROOT_ELEMENT_ID = `${APP_NAME}-root`;

/**
 * Translations endpoint
 */
export const TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';

/**
 * SWR config
 */
export const swrConfig: SWRConfiguration = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,
  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: (
    error: ApiError,
    key: string,
    config: SWRConfiguration,
    revalidate: Revalidator,
    { retryCount }: RevalidatorOptions,
  ) => {
    const statusCode = Number(error.data.status ?? 200);
    if (statusCode >= 400 && statusCode < 500) {
      return;
    }
    const rCount = retryCount ?? 1;
    if (rCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({ retryCount: rCount }), config.errorRetryInterval);
  },
  /* eslint-enable max-params */
};
